<template>
  <div class='pay-content' v-if='showPayContract'>
    <div class='content-info'>
      <span>可以签额度：{{ quotaNumber }} 次</span>
      <a-select v-model="rechargeCode" class='select-name' placeholder="请选择充值类型">
        <a-select-option v-for="item in rechargeOptions" :key="item.key" :value="item.key">{{ item.value }}
        </a-select-option>
      </a-select>
      <a-button style="margin-left: 20px" type="primary" @click="rechargeEvent()">立即充值</a-button>
    </div>
    <a-modal title="支付" v-model="dialogRechargeVisible" :footer="null" width="500px" @cancel="handlePayCancel">
      <a-form label-width="0">
        <a-form-item>
          <div class='pay-image'>
            <img :src="erWeiMaImageSrc" style="width: 200px;height: 200px"/>
            <div style="text-align: center;width: 200px;">微信扫一扫，完成支付</div>
          </div>
        </a-form-item>
        <div class="pay-success-text" v-if="payStatus === true">
          <p>扫码支付成功！</p>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'payContractNumber',
  components: {},
  props: {},
  computed: {
    ...mapState({
      showPayContract: state => state.config.showPayContract
    })
  },
  data() {
    return {
      payStatus: false,
      dialogRechargeVisible: false,
      platformId: '',
      merchantId: '',
      rechargeCode: undefined,
      rechargeOptions: [],
      erWeiMaImageSrc: '',
      quotaNumber: 0
    }
  },
  mounted() {
    let userInfo = this.$store.getters.userInfo
    this.platformId = this.getPlatformConfig().platformId
    this.merchantId = userInfo.merchantId
    this.getPactRechargeType()
    this.getPactSignNum()
    this.getLogUtils().logWithTag('我更新mounted')
  },
  beforeDestroy() {
    this.clearTimeout()
  },
  watch: {
    $route: function(to, form) {
      this.getLogUtils().logWithTag('我更新路由', to)
      this.rechargeCode = undefined
      this.payStatus = false
      this.dialogRechargeVisible = false
      this.getPactSignNum()
    }
  },
  methods: {
    rechargeEvent() {
      if (this.rechargeCode !== undefined) {
        this.erWeiMaImageSrc = this.$store.getters.appConfig.serviceUrl + '/pact/pactRecharge?pactPlatformId=' + this.platformId +
          '&pactMerchantId=' + +this.merchantId + '&pactRechargeTypeKey=' + this.rechargeCode
        this.payStatus = false
        this.dialogRechargeVisible = true
        this.$nextTick(() => {
          this.timeout()
        })
      } else {
        this.$message.error('请选择充值类型')
      }
    },
    getPactRechargeType() {
      this.getHttpServices().getServerApiService().get('pact/getPactRechargeType')
        .then(list => {
          this.rechargeOptions = list
          this.getLogUtils().logWithTag('getPactRechargeType', list)
        }).catch(err => {
        this.getLogUtils().errorWithTag('getPactRechargeType', err)
      })
    },
    timeout() {
      this.timer = setInterval(this.queryOrderPayStatus, 1000)
    },
    clearTimeout() {
      clearInterval(this.timer)
      this.timer = null
    },
    queryOrderPayStatus() {
      let url = 'pact/getPrOrderPayStatus?pactPlatformId=' + this.platformId + '&pactMerchantId=' + +this.merchantId
      this.getHttpServices().getServerApiService().get(url)
        .then(status => {
          this.getLogUtils().logWithTag('queryOrderPayStatus', status)
          if (status === 1) {
            this.payStatus = true
            this.dialogRechargeVisible = false
            this.clearTimeout()
          }
        }).catch(reason => {
        this.payStatus = false
        this.getLogUtils().errorWithTag('queryOrderPayStatus', reason)
        this.clearTimeout()
      })
    },
    handlePayCancel() {
      this.clearTimeout()
    },
    getPactSignNum() {
      this.getHttpServices().getServerApiService().post('pact/getPactSignNum', {
        merchantId: this.merchantId,
        platformId: this.platformId
      }).then(res => {
        if (res) {
          this.quotaNumber = res.pactSignNum ? res.pactSignNum : 0
        }
        this.getLogUtils().logWithTag('getPactSignNum', res)
      }).catch(err => {
        this.getLogUtils().errorWithTag('getPactSignNum', err)
      })
    }
  }
}
</script>

<style scoped>
.pay-content {
  display: inline-block;
}

.select-name {
  width: 200px;
  margin-left: 20px;
}

.pay-image {
  border: 1px solid #444444;
  width: 202px;
  margin: 0 auto;
}

.pay-success-text {
  color: #67C23A;
  font-size: 30px;
  text-align: center;
}
</style>